export { HatchbackCarIcon } from './car-shape-hatchback'
